export type EchoChoice = 'wild' | 'brave' | 'tender'

export const experienceState = {
  progress: 0,
  smoothProgress: 0,
  velocity: 0,
  started: false,
  releasePulse: 0,
  choice: 'wild' as EchoChoice,
  reducedMotion: false,
}

export const chapterStops = [0, 0.205, 0.425, 0.645, 0.845, 1]

export const echoColors: Record<EchoChoice, string> = {
  wild: '#ef5b38',
  brave: '#79d9c5',
  tender: '#e7b6a3',
}
